import axios from "axios";
import { useNavigate } from "react-router-dom";
import http from "../reduxSaga/sagas/requests/http-common";
import TokenService from "./token";
import AuthentificationService from "./authentification";
import { beginRequest, endRequest } from "./loadingOverlay";

// Set timeout to 30 minutes (1800000 ms)
// http.defaults.timeout = 1800000;
// Set timeout to 15 minutes (900000 ms)
http.defaults.timeout = 900000;

// Méthodes qui modifient des données : on affiche un overlay de chargement qui
// bloque les clics (donc le double-clic) tant que la requête est en cours.
const MUTATING_METHODS = new Set(["post", "put", "patch", "delete"]);

http.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    const method = (config.method || "get").toLowerCase();
    if (MUTATING_METHODS.has(method)) {
      config.__globalLoading = true;
      beginRequest();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (res) => {
    if (res.config && res.config.__globalLoading) {
      endRequest();
    }
    return res;
  },
  async (err) => {
    if (err.config && err.config.__globalLoading) {
      endRequest();
    }
    const originalConfig = err.config;
    if (originalConfig.url !== "/authenticate" && err.response) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        try {

           TokenService.removeUser();
          localStorage.removeItem("status");
          localStorage.setItem("accessIsDenied", "denied");
          AuthentificationService.logout();
          window.location.href = "/";
          const res = await axios.post(
            "/refresh_token",
            {
              refreshToken: TokenService.getLocalRefreshToken(),
            }
          );

          const newAccessToken = res.data?.accessToken;
          TokenService.updateLocalAccessToken(newAccessToken);

          // Réessaie la requête initiale avec le nouveau token
          return http(originalConfig);

          // const rs = await http.post("/refreshtoken", {
          //   refreshToken: TokenService.getLocalRefreshToken(),
          // });
          // // console.log(rs.data.errorCode);

          // const accessToken = rs.data?.accessToken;
          // // console.log(accessToken);
          // TokenService.updateLocalAccessToken(accessToken);
          // return http(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
      if (
        err.response.status === 403 &&
        originalConfig.url === "/refreshtoken" &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true;
        try {
          console.log("it is here ", err.response.status);

          TokenService.removeUser();
          localStorage.removeItem("status");
          localStorage.setItem("accessIsDenied", "denied");
          window.location.href = "/login";
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);
export default http;
